import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Clock } from "lucide-react";

interface OpenIssueAgeData {
  averageAge: number;
  ageDistribution: {
    label: string;
    count: number;
    percentage: number;
    color: string;
  }[];
}

interface OpenIssuesTrendCardProps {
  data: OpenIssueAgeData;
  onClick: () => void;
}

export function OpenIssuesTrendCard({ data, onClick }: OpenIssuesTrendCardProps) {
  return (
    <Card className="cursor-pointer hover:bg-accent/50 transition-colors" onClick={onClick}>
      <CardHeader className="pb-3">
        <CardTitle className="text-base font-medium">Open Issue Age</CardTitle>
        <p className="text-xs text-muted-foreground">Current issue aging</p>
      </CardHeader>
      <CardContent className="space-y-3">
        {/* Average Age */}
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-orange-100 flex items-center justify-center">
            <Clock className="h-5 w-5 text-orange-600" />
          </div>
          <div>
            <p className="text-2xl font-bold leading-none">{data.averageAge}</p>
            <p className="text-xs text-muted-foreground leading-none mt-1">Average days open</p>
          </div>
        </div>

        {/* Age Distribution Bars */}
        <div className="space-y-2">
          {data.ageDistribution.map((item) => (
            <div key={item.label} className="space-y-1">
              <div className="flex items-center justify-between text-xs">
                <span className="text-muted-foreground">{item.label}</span>
                <span className="font-medium">{item.count} issues</span>
              </div>
              <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
                <div className={`h-full ${item.color}`} style={{ width: `${item.percentage}%` }} />
              </div>
            </div>
          ))}
        </div>

        {/* Summary */}
        <div className="pt-2 border-t text-xs text-muted-foreground">
          Click to view all open issues
        </div>
      </CardContent>
    </Card>
  );
}
